import type { ResponseContentPerilakuKerja } from 'types/kinerja'
import type {
  ResponseKinerjaKs,
  ResponseContentKinerjaKSUtama,
} from 'types/kinerja-ks'

export const SKP_DATA: ResponseKinerjaKs = {
  data: {
    id: 'O16e1An6N2',
    pangkatGolongan: 'LTIII/A',
    jenjang: 'Bawah Pertama',
    tahun: 2024,
    period: 1,
    status: 'DRAFT',
    kepemimpinanSatuanPendidikan: [],
    pengembanganKompetensi: [],
    rencanaHasilKerjaEkstra: [],
    perilakuKerja: [],

    ekinEligible: false,
    kategoriAsn: false,
    isPadan: false,
    tipe: 'SPF',
  },
  meta: {
    skpYear: 2024,
    skpPeriod: 2,
  },
}

export const CONTENT_KINERJA_UTAMA: ResponseContentKinerjaKSUtama = {
  data: {
    jenjangId: 5,
    jenjang: 'Bawah Pertama',
    kepemimpinanSatuanPendidikan: [
      {
        id: 55,
        nama: 'Memandu perencanaan pembelajaran',
        definisi:
          'Upaya memandu pertemuan perencanaan program dan anggaran sekolah berbasis data untuk peningkatan kualitas pembelajaran.',
        rencanaHasilKerja:
          'Meningkatnya praktik kinerja kepala sekolah melalui observasi kinerja yang berfokus pada memandu perencanaan pembelajaran',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 210,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Kepala Sekolah',
          },
        ],
        perspektif: 'Proses Bisnis',
        iconName: 'img-chalk-board-document-progress.png',
      },
      {
        id: 56,
        nama: 'Presentasi visi-misi sekolah',
        definisi:
          'Upaya mempresentasikan visi-misi dan prioritas satuan pendidikan yang berpusat pada peningkatan kualitas pembelajaran.',
        rencanaHasilKerja:
          'Meningkatnya praktik kinerja kepala sekolah melalui observasi kinerja yang berfokus pada presentasi visi dan misi satuan pendidikan',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 211,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Kepala Sekolah',
          },
        ],
        perspektif: 'Proses Bisnis',
        iconName: 'img-presentation-vision-mission.png',
      },
      {
        id: 57,
        nama: 'Presentasi program sekolah ',
        definisi:
          'Upaya melakukan presentasi persuasif tentang program sekolah berbasis data untuk peningkatan kualitas pembelajaran.',
        rencanaHasilKerja:
          'Meningkatnya praktik kinerja kepala sekolah melalui observasi kinerja yang berfokus pada penyampaian program satuan pendidikan',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 212,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Kepala Sekolah',
          },
        ],
        perspektif: 'Proses Bisnis',
        iconName: 'img-presentation-data-chart.png',
      },
      {
        id: 58,
        nama: 'Refleksi pengelolaan kurikulum satuan pendidikan',
        definisi:
          'Upaya memandu refleksi pelaksanaan kurikulum satuan pendidikan yang berpusat pada peningkatan kualitas pembelajaran.',
        rencanaHasilKerja:
          'Meningkatnya praktik kinerja kepala sekolah melalui observasi kinerja yang berfokus pada refleksi pengelolaan kurikulum satuan pendidikan',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 213,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Kepala Sekolah',
          },
        ],
        perspektif: 'Proses Bisnis',
        iconName: 'img-book-magnifying-glass-stars.png',
      },
      {
        id: 59,
        nama: 'Aktivasi kegiatan komunitas belajar',
        definisi:
          'Upaya mempresentasikan arahan untuk memotivasi guru aktif terlibat kegiatan komunitas belajar untuk peningkatan kualitas pembelajaran.',
        rencanaHasilKerja:
          'Meningkatnya praktik kinerja kepala sekolah melalui observasi kinerja yang berfokus pada aktivasi kegiatan komunitas belajar',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 214,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Kepala Sekolah',
          },
        ],
        perspektif: 'Proses Bisnis',
        iconName: 'img-community-character-emoji-interaction.png',
      },
      {
        id: 60,
        nama: 'Siklus peningkatan kualitas praktik pembelajaran',
        definisi:
          'Upaya melakukan persiapan, pelaksanaan dan tindak lanjut observasi kinerja guru untuk peningkatan kualitas pembelajaran.',
        rencanaHasilKerja:
          'Meningkatnya praktik kinerja kepala sekolah melalui observasi kinerja yang berfokus pada pembimbingan peningkatan kualitas praktik pembelajaran',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 215,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Kepala Sekolah',
          },
        ],
        perspektif: 'Proses Bisnis',
        iconName: 'img-circulation-progress-chart-data-document.png',
      },
      {
        id: 61,
        nama: 'Menceritakan praktik baik kepemimpinan pembelajaran',
        definisi:
          'Upaya mendokumentasikan dan menceritakan praktik baik kepemimpinan pembelajaran kepada komunitas belajar kepala sekolah.',
        rencanaHasilKerja:
          'Meningkatnya praktik kinerja kepala sekolah melalui observasi kinerja yang berfokus pada berbagi praktik baik kepemimpinan',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 216,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Kepala Sekolah',
          },
        ],
        perspektif: 'Proses Bisnis',
        iconName: 'img-sharing-chat-emoji-characters.png',
      },
      {
        id: 62,
        nama: 'Refleksi program pengembangan kompetensi guru',
        definisi:
          'Upaya memandu refleksi pelaksanaan program pengembangan kompetensi guru untuk peningkatan kualitas pembelajaran.',
        rencanaHasilKerja:
          'Meningkatnya praktik kinerja kepala sekolah melalui observasi kinerja yang berfokus pada refleksi program pengembangan kompetensi',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 217,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Kepala Sekolah',
          },
        ],
        perspektif: 'Proses Bisnis',
        iconName: 'img-reflection-documents-magnifying-glass.png',
      },
    ],
    pengembanganKompetensi: [
      {
        id: 78,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui peserta berbagi praktik baik yang diselenggarakan komunitas belajar',
        targetKuantitasMin: 1,
        targetKuantitasMax: 8,
        targetWaktu: 0,
        bobot: 4,
        buktiDukung: [
          {
            id: 233,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 75,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui peserta coaching atau mentoring pengembangan kompetensi oleh Guru, Kepala Sekolah, dan/atau pengawas sekolah',
        targetKuantitasMin: 1,
        targetKuantitasMax: 8,
        targetWaktu: 0,
        bobot: 4,
        buktiDukung: [
          {
            id: 230,
            deskripsi: 'Piagam',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 74,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui partisipan kegiatan seminar, lokakarya, konferensi, simposium, dan/atau studi banding lapangan yang diselenggarakan di bidang pendidikan',
        targetKuantitasMin: 1,
        targetKuantitasMax: 8,
        targetWaktu: 0,
        bobot: 4,
        buktiDukung: [
          {
            id: 229,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 70,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui penelaah aksi nyata sejawat yang dihasilkan Guru dan/atau Kepala Sekolah lain',
        targetKuantitasMin: 1,
        targetKuantitasMax: 6,
        targetWaktu: 0,
        bobot: 6,
        buktiDukung: [
          {
            id: 225,
            deskripsi: 'Perangkat Ajar yang terbit di Ruang GTK',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 71,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui penelaah perangkat ajar yang dihasilkan Guru dan/atau Kepala Sekolah lain',
        targetKuantitasMin: 1,
        targetKuantitasMax: 6,
        targetWaktu: 0,
        bobot: 6,
        buktiDukung: [
          {
            id: 226,
            deskripsi: 'Kumpulan Konten Unggulan yang terbit di Ruang GTK',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 68,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui penelaah cerita praktik yang dihasilkan Guru dan/atau Kepala Sekolah lain',
        targetKuantitasMin: 1,
        targetKuantitasMax: 6,
        targetWaktu: 0,
        bobot: 6,
        buktiDukung: [
          {
            id: 223,
            deskripsi: 'Laporan',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 66,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui penyusun kumpulan konten unggulan yang dapat dibagikan kepada Guru dan/atau Kepala Sekolah lain',
        targetKuantitasMin: 1,
        targetKuantitasMax: 6,
        targetWaktu: 0,
        bobot: 6,
        buktiDukung: [
          {
            id: 221,
            deskripsi: 'Cerita Praktik yang terbit di Ruang GTK',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 77,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui peserta pelatihan mandiri sesuai model kompetensi Guru, Kepala Sekolah, dan/atau pengawas sekolah',
        targetKuantitasMin: 1,
        targetKuantitasMax: 4,
        targetWaktu: 0,
        bobot: 8,
        buktiDukung: [
          {
            id: 232,
            deskripsi: 'Laporan',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 76,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui peserta kegiatan pelatihan atau bimbingan teknis yang memperoleh sertifikat di bidang pendidikan, kebudayaan, riset dan teknologi',
        targetKuantitasMin: 1,
        targetKuantitasMax: 4,
        targetWaktu: 0,
        bobot: 8,
        buktiDukung: [
          {
            id: 231,
            deskripsi: 'Laporan',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 67,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui narasumber berbagi praktik baik dalam kegiatan yang terkait implementasi Kurikulum Merdeka dan/atau Perencanaan Berbasis Data',
        targetKuantitasMin: 1,
        targetKuantitasMax: 4,
        targetWaktu: 0,
        bobot: 8,
        buktiDukung: [
          {
            id: 222,
            deskripsi: 'Laporan',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 72,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui partisipan observasi praktik pembelajaran (persiapan, pelaksanaan, dan diskusi tindak lanjut) bersama rekan sejawat',
        targetKuantitasMin: 1,
        targetKuantitasMax: 4,
        targetWaktu: 0,
        bobot: 8,
        buktiDukung: [
          {
            id: 227,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 69,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui penyusun cerita praktik yang dapat dibagikan kepada Guru dan/atau Kepala Sekolah lain',
        targetKuantitasMin: 1,
        targetKuantitasMax: 3,
        targetWaktu: 0,
        bobot: 12,
        buktiDukung: [
          {
            id: 224,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 65,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui peraih pengakuan atau penghargaan terhadap kompetensi dan kinerjanya dalam berbagai wadah atau ajang',
        targetKuantitasMin: 1,
        targetKuantitasMax: 3,
        targetWaktu: 0,
        bobot: 12,
        buktiDukung: [
          {
            id: 220,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 73,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui coach, mentor, fasilitator, dan/atau pengajar praktik dalam kegiatan pengembangan kompetensi kepada Guru, Kepala Sekolah, dan/atau pengawas sekolah',
        targetKuantitasMin: 1,
        targetKuantitasMax: 3,
        targetWaktu: 0,
        bobot: 12,
        buktiDukung: [
          {
            id: 228,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 64,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui penyusun perangkat ajar yang dapat dibagikan kepada Guru dan/atau Kepala Sekolah lain',
        targetKuantitasMin: 1,
        targetKuantitasMax: 2,
        targetWaktu: 0,
        bobot: 24,
        buktiDukung: [
          {
            id: 219,
            deskripsi: 'Sertifikat Topik',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 80,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui peserta praktik magang pada dunia kerja dan/atau bidang lain yang relevan',
        targetKuantitasMin: 1,
        targetKuantitasMax: 2,
        targetWaktu: 0,
        bobot: 24,
        buktiDukung: [
          {
            id: 235,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 63,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui penggerak komunitas belajar dengan mengadakan minimal 3 kegiatan berbagi praktik baik',
        targetKuantitasMin: 1,
        targetKuantitasMax: 1,
        targetWaktu: 0,
        bobot: 36,
        buktiDukung: [
          {
            id: 218,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
      {
        id: 79,
        rencanaHasilKerja:
          'Meningkatnya kinerja satuan pendidikan dan/atau peningkatan karier Kepala Sekolah melalui peserta program pelatihan dan pendidikan jangka pendek atau menengah pada bidang kepemimpinan dan bidang teknis yang relevan, seperti pelatihan manajerial Kepala Sekolah',
        targetKuantitasMin: 1,
        targetKuantitasMax: 1,
        targetWaktu: 0,
        bobot: 128,
        buktiDukung: [
          {
            id: 234,
            deskripsi: 'Sertifikat',
          },
        ],
        perspektif: 'Penguatan Internal',
        catatan: '',
      },
    ],
    rencanaHasilKerjaEkstra: [
      {
        id: 87,
        nama: 'Terkelolanya penugasan Guru dan tenaga kependidikan untuk mewujudkan penyelenggaraan pembelajaran yang berkualitas',
        definisi: '',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 242,
            deskripsi: 'Surat Penugasan',
          },
        ],
        perspektif: 'Penerima Layanan',
        position: {
          order: 7,
          placeOnTop: false,
        },
        rencanaHasilKerja: '',
        iconName: '',
      },
      {
        id: 84,
        nama: 'Terkelolanya pelaksanaan pembelajaran yang berfokus pada implementasi Kurikulum Operasional Satuan Pendidikan (KOSP)',
        definisi: '',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 239,
            deskripsi: 'Rangkuman Kehadiran Guru',
          },
        ],
        perspektif: 'Penerima Layanan',
        position: {
          order: 6,
          placeOnTop: false,
        },
        rencanaHasilKerja: '',
        iconName: '',
      },
      {
        id: 82,
        nama: 'Terkelolanya kegiatan pengembangan kompetensi guru dan tenaga kependidikan',
        definisi: '',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 237,
            deskripsi: 'Rekapitulasi Bukti Dukung Pengembangan Kompetensi Guru',
          },
        ],
        perspektif: 'Penguatan Internal',
        position: {
          order: 5,
          placeOnTop: false,
        },
        rencanaHasilKerja: '',
        iconName: '',
      },
      {
        id: 81,
        nama: 'Terlaksananya peningkatan kualitas praktik pembelajaran guru',
        definisi: '',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 236,
            deskripsi: 'Hasil Penilaian Praktik Kinerja Guru',
          },
        ],
        perspektif: 'Penerima Layanan',
        position: {
          order: 4,
          placeOnTop: false,
        },
        rencanaHasilKerja: '',
        iconName: '',
      },
      {
        id: 86,
        nama: 'Tersusunnya laporan pengelolaan satuan pendidikan yang berorientasi pada peningkatan pembelajaran',
        definisi: '',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 241,
            deskripsi: 'Dokumen Laporan Satuan Pendidikan',
          },
        ],
        perspektif: 'Anggaran',
        position: {
          order: 3,
          placeOnTop: false,
        },
        rencanaHasilKerja: '',
        iconName: '',
      },
      {
        id: 85,
        nama: 'Tersusunnya perencanaan satuan pendidikan yang berorientasi pada peningkatan pembelajaran',
        definisi: '',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 240,
            deskripsi: 'Dokumen Perencanaan Satuan Pendidikan',
          },
        ],
        perspektif: 'Anggaran',
        position: {
          order: 2,
          placeOnTop: false,
        },
        rencanaHasilKerja: '',
        iconName: '',
      },
      {
        id: 83,
        nama: 'Tersusunnya Kurikulum Operasional Satuan Pendidikan (KOSP) yang berorientasi pada peningkatan pembelajaran secara partisipatif',
        definisi: '',
        targetKuantitas: '1 kegiatan',
        targetWaktu: 0,
        buktiDukung: [
          {
            id: 238,
            deskripsi: 'Dokumen Kurikulum Operasional Satuan Pendidikan (KOSP)',
          },
        ],
        perspektif: 'Proses Bisnis',
        position: {
          order: 1,
          placeOnTop: false,
        },
        rencanaHasilKerja: '',
        iconName: '',
      },
    ],
  },
  meta: {},
}

export const CONTENT_PERILAKU_KERJA: ResponseContentPerilakuKerja = {
  data: {
    aspek: [
      {
        id: 100,
        orderAspek: 1,
        value: 'Berorientasi Pelayanan',
        indikator: [
          {
            id: 100,
            orderIndikator: 1,
            value:
              'Memahami kebutuhan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja',
            ekspektasi: [
              {
                id: 100,
                orderEkspektasi: 1,
                value:
                  'Mengidentifikasi kebutuhan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja secara proaktif',
              },
              {
                id: 101,
                orderEkspektasi: 2,
                value:
                  'Memenuhi kebutuhan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja secara responsif',
              },
              {
                id: 102,
                orderEkspektasi: 3,
                value:
                  'Melayani guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja dengan aspirasi dan/atau keluhan yang diterima',
              },
              {
                id: 103,
                orderEkspektasi: 4,
                value:
                  'Menyelesaikan keluhan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja dengan komunikasi persuasif',
              },
            ],
          },
          {
            id: 101,
            orderIndikator: 2,
            value:
              'Bersifat ramah kepada peserta didik, guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja tanpa membeda-bedakan, cekatan dalam bekerja, solutif dalam mengatasi permasalahan pembelajaran, dan dapat diandalkan',
            ekspektasi: [
              {
                id: 104,
                orderEkspektasi: 1,
                value: 'Menuntaskan semua pekerjaan',
              },
              {
                id: 105,
                orderEkspektasi: 2,
                value: 'Mengucapkan salam dan sapa dengan sikap ramah',
              },
              {
                id: 106,
                orderEkspektasi: 3,
                value: 'Mengkomunikasikan informasi yang aktual dan akurat',
              },
              {
                id: 107,
                orderEkspektasi: 4,
                value:
                  'Melayani dengan standar yang sama guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja',
              },
            ],
          },
          {
            id: 102,
            orderIndikator: 3,
            value:
              'Melakukan perbaikan terus-menerus terhadap kompetensi dan perilaku kerjanya',
            ekspektasi: [
              {
                id: 108,
                orderEkspektasi: 1,
                value: 'Memperbaiki kualitas layanan secara terus-menerus',
              },
              {
                id: 109,
                orderEkspektasi: 2,
                value:
                  'Menindaklanjuti setiap kritik dan saran secara konstruktif',
              },
              {
                id: 110,
                orderEkspektasi: 3,
                value: 'Berupaya memperluas wawasan kualitas pelayanan',
              },
            ],
          },
        ],
      },
      {
        id: 101,
        orderAspek: 2,
        value: 'Akuntabel',
        indikator: [
          {
            id: 103,
            orderIndikator: 1,
            value:
              'Melaksanakan tugas dengan jujur, bertanggung jawab, cermat, disiplin, dan berintegritas tinggi',
            ekspektasi: [
              {
                id: 111,
                orderEkspektasi: 1,
                value: 'Memenuhi janji dan komitmen terkait pekerjaan',
              },
              {
                id: 112,
                orderEkspektasi: 2,
                value: 'Melaksanakan pekerjaan sesuai dengan ketentuan',
              },
              {
                id: 113,
                orderEkspektasi: 3,
                value:
                  'Bertanggung jawab atas hasil kerja yang dilakukan dan bersedia dievaluasi',
              },
              {
                id: 114,
                orderEkspektasi: 4,
                value:
                  'Menolak segala bentuk gratifikasi, korupsi, kolusi, dan nepotisme',
              },
            ],
          },
          {
            id: 104,
            orderIndikator: 2,
            value:
              'Memanfaatkan sumber daya satuan pendidikan dengan bertanggung jawab, efektif, dan efisien',
            ekspektasi: [
              {
                id: 115,
                orderEkspektasi: 1,
                value:
                  'Memanfaatkan fasilitas satuan pendidikan sesuai dengan peruntukannya',
              },
              {
                id: 116,
                orderEkspektasi: 2,
                value:
                  'Mencari cara efisiensi penggunaan sarana prasarana, bahan, dan alat kerja satuan pendidikan',
              },
            ],
          },
          {
            id: 105,
            orderIndikator: 3,
            value:
              'Tidak menyalahgunakan kewenangan jabatannya demi keuntungan pribadi',
            ekspektasi: [
              {
                id: 117,
                orderEkspektasi: 1,
                value:
                  'Menghindari situasi yang menimbulkan konflik kepentingan pribadi',
              },
              {
                id: 118,
                orderEkspektasi: 2,
                value:
                  'Mengambil keputusan dengan objektif saat terjadi konflik kepentingan',
              },
            ],
          },
        ],
      },
      {
        id: 102,
        orderAspek: 3,
        value: 'Kompeten',
        indikator: [
          {
            id: 106,
            orderIndikator: 1,
            value:
              'Melaksanakan peningkatan kompetensi untuk merespon kebutuhan belajar guru dan tenaga kependidikan',
            ekspektasi: [
              {
                id: 119,
                orderEkspektasi: 1,
                value:
                  'Meningkatkan kapasitas dan kompetensi diri secara terus-menerus',
              },
              {
                id: 120,
                orderEkspektasi: 2,
                value:
                  'Berdiskusi dengan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja mencari solusi',
              },
            ],
          },
          {
            id: 107,
            orderIndikator: 2,
            value:
              'Membantu guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja untuk saling belajar',
            ekspektasi: [
              {
                id: 121,
                orderEkspektasi: 1,
                value:
                  'Memberikan kesempatan kepada guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja untuk menyampaikan pendapat',
              },
              {
                id: 122,
                orderEkspektasi: 2,
                value:
                  'Membagikan pengetahuan dan pengalaman melalui diskusi dan dialog bersama guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja',
              },
            ],
          },
          {
            id: 108,
            orderIndikator: 3,
            value: 'Melaksanakan tugas dengan kualitas terbaik',
            ekspektasi: [
              {
                id: 123,
                orderEkspektasi: 1,
                value:
                  'Menyusun rencana kerja dan/atau anggaran dengan spesifik dan partisipatif',
              },
              {
                id: 124,
                orderEkspektasi: 2,
                value:
                  'Melaksanakan rencana kerja dan/atau anggaran sesuai target yang ditetapkan',
              },
              {
                id: 125,
                orderEkspektasi: 3,
                value: 'Menyelesaikan masalah secara komprehensif dan tuntas',
              },
            ],
          },
        ],
      },
      {
        id: 103,
        orderAspek: 4,
        value: 'Harmonis',
        indikator: [
          {
            id: 109,
            orderIndikator: 1,
            value:
              'Menghargai setiap warga satuan sekolah apapun latar belakangnya',
            ekspektasi: [
              {
                id: 126,
                orderEkspektasi: 1,
                value:
                  'Berlaku adil kepada setiap orang tanpa memandang, kedudukan, jabatan, latar belakang, suku, agama, ras dan jenis kelamin',
              },
              {
                id: 127,
                orderEkspektasi: 2,
                value:
                  'Menjaga hubungan yang baik dengan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja',
              },
              {
                id: 128,
                orderEkspektasi: 3,
                value: 'Menghormati gagasan yang disampaikan orang lain',
              },
            ],
          },
          {
            id: 110,
            orderIndikator: 2,
            value:
              'Memberikan pertolongan bagi warga satuan pendidikan yang memerlukan',
            ekspektasi: [
              {
                id: 129,
                orderEkspektasi: 1,
                value:
                  'Menawarkan solusi kepada warga sekolah dengan responsif',
              },
              {
                id: 130,
                orderEkspektasi: 2,
                value: 'Memberikan solusi dan/atau informasi sesuai kewenangan',
              },
            ],
          },
          {
            id: 111,
            orderIndikator: 3,
            value: 'Membangun lingkungan pembelajaran yang kondusif',
            ekspektasi: [
              {
                id: 131,
                orderEkspektasi: 1,
                value:
                  'Menyelesaikan konflik di antara guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja secara konstruktif',
              },
              {
                id: 132,
                orderEkspektasi: 2,
                value:
                  'Berinteraksi dengan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja dengan sopan dan menjunjung tinggi etika',
              },
              {
                id: 133,
                orderEkspektasi: 3,
                value:
                  'Menghindari diskusi yang berpotensi menimbulkan konflik SARA',
              },
            ],
          },
        ],
      },
      {
        id: 104,
        orderAspek: 5,
        value: 'Loyal',
        indikator: [
          {
            id: 112,
            orderIndikator: 1,
            value:
              'Memegang teguh moral dan mematuhi peraturan perundang-undangan yang berlaku',
            ekspektasi: [
              {
                id: 134,
                orderEkspektasi: 1,
                value:
                  'Menghindari tindakan, ucapan, perbuatan yang menjurus pada perpecahan',
              },
              {
                id: 135,
                orderEkspektasi: 2,
                value:
                  'Menyebarkan informasi yang mendukung transformasi pembelajaran',
              },
              {
                id: 136,
                orderEkspektasi: 3,
                value:
                  'Mencegah situasi yang mengancam integritas satuan pendidikan',
              },
            ],
          },
          {
            id: 113,
            orderIndikator: 2,
            value:
              'Menjaga nama baik satuan pendidikan, guru, tenaga kependidikan dan peserta didik dimanapun berada',
            ekspektasi: [
              {
                id: 137,
                orderEkspektasi: 1,
                value:
                  'Bersikap dan berperilaku yang melindungi nama baik serta citra satuan pendidikan',
              },
              {
                id: 138,
                orderEkspektasi: 2,
                value:
                  'Melaksanakan arahan atasan yang sesuai dengan norma dan ketentuan yang berlaku',
              },
              {
                id: 139,
                orderEkspektasi: 3,
                value:
                  'Menyebarkan informasi positif tentang transformasi pembelajaran',
              },
            ],
          },
          {
            id: 114,
            orderIndikator: 3,
            value:
              'Menjaga informasi yang bersifat sensitif dan berpotensi merugikan peserta didik dan satuan pendidikan',
            ekspektasi: [
              {
                id: 140,
                orderEkspektasi: 1,
                value:
                  'Menyimpan informasi sensitif dengan cara dan pada tempat yang aman',
              },
              {
                id: 141,
                orderEkspektasi: 2,
                value:
                  'Membagikan informasi sensitif hanya kepada pihak yang berwenang',
              },
              {
                id: 142,
                orderEkspektasi: 3,
                value:
                  'Mencegah situasi yang mengancam keamanan peserta didik dan satuan pendidikan',
              },
            ],
          },
        ],
      },
      {
        id: 105,
        orderAspek: 6,
        value: 'Adaptif',
        indikator: [
          {
            id: 115,
            orderIndikator: 1,
            value:
              'Menyesuaikan diri secara cepat dalam menghadapi dinamika masyarakat',
            ekspektasi: [
              {
                id: 143,
                orderEkspektasi: 1,
                value: 'Menyesuaikan diri di berbagai lingkungan kerja',
              },
              {
                id: 144,
                orderEkspektasi: 2,
                value: 'Beradaptasi dengan dinamika perubahan lingkungan',
              },
              {
                id: 145,
                orderEkspektasi: 3,
                value: 'Menguasai dinamika perkembangan teknologi',
              },
            ],
          },
          {
            id: 116,
            orderIndikator: 2,
            value:
              'Terus berinovasi dan mengembangkan kreativitas untuk memajukan satuan pendidikan',
            ekspektasi: [
              {
                id: 146,
                orderEkspektasi: 1,
                value:
                  'Menyampaikan ide dan gagasan untuk kemajuan satuan pendidikan dengan berani',
              },
              {
                id: 147,
                orderEkspektasi: 2,
                value:
                  'Membuat inovasi yang mendukung tujuan satuan pendidikan secara konsisten',
              },
              {
                id: 148,
                orderEkspektasi: 3,
                value: 'Mengantisipasi permasalahan yang terjadi dengan kritis',
              },
              {
                id: 149,
                orderEkspektasi: 4,
                value:
                  'Menjalankan sistem kerja yang berbasis teknologi informasi',
              },
            ],
          },
          {
            id: 117,
            orderIndikator: 3,
            value:
              'Berpikir proaktif untuk mengembangkan diri, guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja',
            ekspektasi: [
              {
                id: 150,
                orderEkspektasi: 1,
                value: 'Mengidentifikasi potensi masalah dan solusinya',
              },
              {
                id: 151,
                orderEkspektasi: 2,
                value:
                  'Menunjukkan keingintahuan yang tinggi terhadap hal baru',
              },
              {
                id: 152,
                orderEkspektasi: 3,
                value:
                  'Memanfaatkan peluang untuk menghasilkan hal yang lebih baik',
              },
            ],
          },
        ],
      },
      {
        id: 106,
        orderAspek: 7,
        value: 'Kolaboratif',
        indikator: [
          {
            id: 118,
            orderIndikator: 1,
            value:
              'Memberi kesempatan kepada warga satuan pendidikan dan masyarakat atau dunia kerja untuk berkontribusi bagi tujuan pembelajaran yang berpusat pada peserta didik',
            ekspektasi: [
              {
                id: 153,
                orderEkspektasi: 1,
                value: 'Menerima pendapat dan saran dalam menyelesaikan tugas',
              },
              {
                id: 154,
                orderEkspektasi: 2,
                value: 'Memuji keunggulan dan prestasi orang lain',
              },
              {
                id: 155,
                orderEkspektasi: 3,
                value:
                  'Membagi tugas, tanggung jawab, hak dan kewajiban kepada guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja secara proporsional',
              },
            ],
          },
          {
            id: 119,
            orderIndikator: 2,
            value:
              'Bekerja sama secara terbuka dalam menghasilkan dampak pembelajaran yang merata bagi peserta didik, guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja',
            ekspektasi: [
              {
                id: 156,
                orderEkspektasi: 1,
                value:
                  'Mengajukan diri secara sukarela untuk terlibat dalam kegiatan yang mendukung peningkatan pembelajaran',
              },
              {
                id: 157,
                orderEkspektasi: 2,
                value:
                  'Bersinergi dengan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja dalam menyelesaikan tugas',
              },
              {
                id: 158,
                orderEkspektasi: 3,
                value: 'Mengakui saat berbuat kesalahan',
              },
            ],
          },
          {
            id: 120,
            orderIndikator: 3,
            value:
              'Menggerakkan pemanfaatan sumber daya satuan pendidikan untuk pencapaian visi dan misi satuan pendidikan',
            ekspektasi: [
              {
                id: 159,
                orderEkspektasi: 1,
                value:
                  'Mendorong guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja untuk dapat terlibat aktif dalam pencapaian tujuan satuan pendidikan',
              },
              {
                id: 160,
                orderEkspektasi: 2,
                value:
                  'Membangun komunikasi yang efektif dalam berkoordinasi dengan guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja',
              },
              {
                id: 161,
                orderEkspektasi: 3,
                value:
                  'Mengoptimalkan sumber daya yang mendukung pencapaian kinerja satuan pendidikan',
              },
            ],
          },
        ],
      },
    ],
  },
  meta: {},
}
